import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f97fdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bold text-center w-100 fs-5 text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body dialog-body d-flex justify-content-center align-items-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "modal-footer justify-content-center" }
const _hoisted_10 = { class: "d-flex justify-content-center button-container" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { PropType, ref } from 'vue'
import { PostType } from '@/store/modules/post'
import { Modal } from 'bootstrap'
import { MODAL_ID } from '@/constants/common'
import { changeModalElevation } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  onConfirm: { type: Function as PropType<(PostType) => Promise<any> | undefined>, required: true },
},
  setup(__props, { expose }) {

const props = __props

const post = ref<PostType>()



const showDialog = (p: PostType) => {
  post.value = p
  const element = document.getElementById(MODAL_ID.INTEREST_CONFIRM)
  element?.addEventListener('hide.bs.modal', () => {
    changeModalElevation('modalPost', 'higher')
  })
  new Modal(element)?.show()
}

expose({
  showDialog,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _unref(MODAL_ID).INTEREST_CONFIRM,
    tabindex: "-1",
    "aria-labelledby": _unref(MODAL_ID).INTEREST_CONFIRM,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(translate)('OF10confirmTitle')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('OF10confirmMessage')), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: "secondary",
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('interest'),
              type: "secondary",
              "data-bs-dismiss": "modal",
              "on-click": () => props.onConfirm(post.value)
            }, null, 8, ["title", "on-click"])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})